export default 'clientsPage';
